import { RomanianApartmentInfoController } from "./RomanianApartmentInfoController";
import { DefaultApartmentInfoController } from "./DefaultApartmentInfoController";
export const ApartmentInfoController = {
    create(apartmentInfo) {
        switch (apartmentInfo.type) {
            case "Default":
                return new DefaultApartmentInfoController({ apartmentInfo });
            case "Romanian":
                return new RomanianApartmentInfoController({ apartmentInfo });
        }
    },
};
